<div class="tvd-wrapper flex flex-col flex-grow gap-6 justify-between min-h-fit ml-[80px] p-[3%] px-8 py-6 bg-light-blue">

    <!-- TODO-AJ Checkin with Nathan about the responsive layout-->
    <div class="tvd-header flex w-full flex-col h-fit sm:gap-2 lg:flex-row lg:justify-between">
        <div class="tvd-header-left flex flex-col gap-2 w-2/3">
            <tvd-overall
                id="tvd-overall"
                [value]=tvdOverallData
                >
            </tvd-overall>

            <div class="tvd-display-rounding-container">
                <toggle-switch label="Display in Rounded Numbers" [isCheckedByDefault]="displayInRoundedNumber" (toggleChange)="toggleRounding()"/>
            </div>

        </div>
        <div class="tvd-header-right flex gap-x-4 gap-y-4 h-fit items-center flex-wrap sm:justify-start lg:justify-end">


            <!-- If in presentation selection mode hide all buttons -->
            <ng-container *ngIf="!makingSelectionsState">

                <div [hidden]="tvdBrandGroupScope!='All'">
                    <button id="select-metrics-button" (click)="toggleMakingSelectionsState()" class="add-to-presentation-button neptune-button-white">
                        <img src="assets/shared-icons/neptune-icon-blue-plus-sign.svg" />
                        <span class="text-base" *ngIf="numMetricsSelected == 0">Add To Presentation</span>
                        <span class="text-base" *ngIf="numMetricsSelected > 0">Edit Selected Metrics</span>
                    </button>
                </div>

                <div *ngIf="showProductMetrics" class="enterprise-terms-button-container flex items-stretch" >
                    <button
                        type="button"
                        class="enterprise-terms-button flex-1 basis-0 whitespace-nowrap rounded-r-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                        [ngClass]="showInEnterpriseTerms ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                        (click)="!showInEnterpriseTerms && toggleShowEnterpriseTerms()"
                    >
                        Enterprise Terms
                    </button>

                    <button
                        type="button"
                        class="division-terms-button flex-1 basis-0 whitespace-nowrap rounded-l-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                        [ngClass]="!showInEnterpriseTerms ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                        (click)="showInEnterpriseTerms && toggleShowEnterpriseTerms()"
                    >
                        Division Terms
                    </button>

                    <div class="information-tooltip flex justify-center items-center ml-2">
                        <information-tooltip [toolTipType]="infoTooltipType.EnterpriseTerms"/>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>

    <div class="tvd-body flex flex-col bg-white gap-6">
        <!-- Switch between different avilable brand groups -->
        <div class="program-switch-container flex grow w-full justify-between items-center ">
            <div *ngFor="let program of availableBrandGroupTabs"
                class="flex justify-center text-sm w-1/3 px-4 py-3 hover-pointer items-center border-solid border-white "
                [ngClass]="tvdBrandGroupScope==program ? 'border-b-blue text-neptune-default': 'text-neptune-neutral'"
                (click)="changeScope(program)"
            > {{program}}
            </div>
        </div>

        <!--
            Use h-[5rem] here to explicitly set a fixed height
            so that the select-box does not expand the parent div
        -->
        <div class="flex justify-between items-center flex-none h-[5rem]">
            <!-- Buttons to Toggle between Product and Business Metrics -->
            <div class="metric-toggle-container flex items-stretch mx-6 shrink-0">
                <button
                    type="button"
                    class="product-metrics-button whitespace-nowrap rounded-r-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                    [ngClass]="showProductMetrics ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                    (click)="!showProductMetrics && toggleProductBusinessMetrics()"
                >
                    Product Metrics
                </button>
                <button
                    type="button"
                    class="business-metrics-button whitespace-nowrap rounded-l-none transition-colors outline-none focus-visible:ring focus-visible:ring-purple-400"
                    [ngClass]="!showProductMetrics ? 'neptune-button-blue' : 'neptune-button-white hover:bg-slate-100'"
                    (click)="showProductMetrics && toggleProductBusinessMetrics()"
                >
                    Business Metrics
                </button>
            </div>
            <!-- Select box to filter the distributor branded data -->
            <div class="tvd-distributor-filters relative right mb-[10px] ml-auto text-black" *ngFor="let filter of filterOptions">
                <select-box
                    *ngIf="tvdBrandGroupScope === 'Distributor' && filter.title === tvdBrandGroupScope"
                    [id]="'tvd-filters-select-' + filter.title"
                    [options]="filter.options"
                    [type]="filter.inputType"
                    [(selectedOptions)]="selectedFilterOptions[filter.title]"
                    (updateSelectedOptions)="updateSelectedOptions()"
                >
                </select-box>
            </div>
        </div>

        <div *ngIf="showProductMetrics" class="tvd-metrics-container flex flex-col grow">
            <div class="tvd-value-pillars flex bg-neptune-gradient mx-6 items-stretch" [ngClass]="expandedValuePillarId || makingSelectionsState ? 'rounded-t-[36px]' : 'rounded-[36px]'">
                <div class="flex grow h-full" [ngClass]="expandedValuePillarId || makingSelectionsState ? 'px-6 pt-6' : 'p-6'">
                    <div *ngFor="let item of valuePillars; trackBy: trackByValuePillar" class="value-pillar w-1/3" [id]="item">
                        <!-- TODO: remove isDataReady gating once component guarantees fully prepared data -->
                        <ng-container *ngIf="isDataReady">
                            <!-- TODO update the value pillar numbers for when distributor brands are filtered. -->
                            <tvd-value-pillar-summary
                                [valuePillar]=item
                                [selectedProgram] = tvdBrandGroupScope
                                [noMetricsForValuePillar]="!hasMetricsForPillar(item)"
                                [isExpanded]="expandedValuePillarId === item"
                                (toggleRequested)="onValuePillarToggle(item)"
                                [makingSelectionsState]="makingSelectionsState"
                            />
                        </ng-container>
                    </div>
                </div>
            </div>

            <div *ngIf="!makingSelectionsState"
                id="business-outcomes-tiles"
                class="gap-6 mx-6 justify-center"
                [ngClass]="{
                    'flex flex-col': expandedValuePillarId === TvdValuePillar.BusinessOutcomes || makingSelectionsState,
                    'hidden': !(expandedValuePillarId === TvdValuePillar.BusinessOutcomes),
                    'rounded-md bg-neptune-special': makingSelectionsState,
                    'border-2 border-solid border-blue': expandedValuePillarId === TvdValuePillar.BusinessOutcomes && makingSelectionsState
                }"
            >
                <tvd-metric-group
                    *ngFor="let metricGroup of tvdProductMetricGroupDataByValuePillar[TvdValuePillar.BusinessOutcomes]"
                    id="{{metricGroup.title}}"
                    [groupId]="metricGroup.id"
                    [groupTitle]= metricGroup.title
                    [metricData]= metricGroup.indvMetrics
                    [makingSelectionsState]="makingSelectionsState"
                    [isGroupSelected]=metricGroup.groupSelected
                    [brandGroup]="tvdBrandGroupScope"
                    [brands]="selectedFilterOptions[tvdBrandGroupScope]"
                    [shouldShowCompositeMetric]="false"
                    (groupMetricSelectionChange)="handleMetricGroupSelectionChange($event)">
                </tvd-metric-group>
            </div>

            <div *ngIf="!makingSelectionsState"
                id="operation-performance-tiles"
                class="gap-6 mx-6 justify-center"
                [ngClass]="{
                    'flex flex-col': expandedValuePillarId === TvdValuePillar.OperationalPerformance || makingSelectionsState,
                    'hidden': !(expandedValuePillarId === TvdValuePillar.OperationalPerformance),
                    'rounded-md bg-neptune-special': makingSelectionsState,
                    'border-2 border-solid border-blue': expandedValuePillarId === TvdValuePillar.OperationalPerformance && makingSelectionsState
                }"
            >
                <tvd-metric-group
                    *ngFor="let metricGroup of tvdProductMetricGroupDataByValuePillar[TvdValuePillar.OperationalPerformance]"
                    id="{{metricGroup.title}}"
                    [groupId]="metricGroup.id"
                    [groupTitle]= metricGroup.title
                    [metricData]= metricGroup.indvMetrics
                    [makingSelectionsState]="makingSelectionsState"
                    [isGroupSelected]=metricGroup.groupSelected
                    [brandGroup]="tvdBrandGroupScope"
                    [brands]="selectedFilterOptions[tvdBrandGroupScope]"
                    [shouldShowCompositeMetric]="false"
                    (groupMetricSelectionChange)="handleMetricGroupSelectionChange($event)">
                </tvd-metric-group>
            </div>

            <div *ngIf="!makingSelectionsState"
                id="environmental-impact-tiles"
                class="gap-6 mx-6 justify-center"
                [ngClass]="{
                    'flex flex-col': expandedValuePillarId === TvdValuePillar.EnvironmentalImpact || makingSelectionsState,
                    'hidden': !(expandedValuePillarId === TvdValuePillar.EnvironmentalImpact),
                    'rounded-md bg-neptune-special': makingSelectionsState,
                    'border-2 border-solid border-blue': expandedValuePillarId === TvdValuePillar.EnvironmentalImpact && makingSelectionsState
                }"
            >
                <tvd-metric-group
                    *ngFor="let metricGroup of tvdProductMetricGroupDataByValuePillar[TvdValuePillar.EnvironmentalImpact]"
                    id="{{metricGroup.title}}"
                    [groupId]="metricGroup.id"
                    [groupTitle]= metricGroup.title
                    [metricData]= metricGroup.indvMetrics
                    [makingSelectionsState]="makingSelectionsState"
                    [isGroupSelected]=metricGroup.groupSelected
                    [brandGroup]="tvdBrandGroupScope"
                    [brands]="selectedFilterOptions[tvdBrandGroupScope]"
                    [shouldShowCompositeMetric]="true"
                    (groupMetricSelectionChange)="handleMetricGroupSelectionChange($event)">
                </tvd-metric-group>
            </div>

        </div>

        <!-- When the "Business Metrics" button is selected, show the business metrics -->
        <div *ngIf="!showProductMetrics && !makingSelectionsState">
            <tvd-metric-group
                *ngFor="let metricGroup of getDistributorBusinessMetrics()"
                id="{{metricGroup.title}}"
                [groupId]="metricGroup.id"
                [groupTitle]= metricGroup.title
                [metricData]= metricGroup.indvMetrics
                [makingSelectionsState]="makingSelectionsState"
                [isGroupSelected]=metricGroup.groupSelected
                [brandGroup]="tvdBrandGroupScope"
                [brands]="selectedFilterOptions[tvdBrandGroupScope]"
                [shouldShowCompositeMetric]="false"
                (groupMetricSelectionChange)="handleMetricGroupSelectionChange($event)">
            </tvd-metric-group>
        </div>

        <!-- If in making selections state, show both Product and Business Metrics as their own groups -->
        <div *ngIf="makingSelectionsState" class="mx-6 flex flex-col bg-white gap-6">
            <tvd-metric-group
                *ngFor="let metricGroup of tvdMetricGroupsDataByBrand"
                id="{{metricGroup.title}}"
                [groupId]="metricGroup.id"
                [groupTitle]= metricGroup.title
                [metricData]= metricGroup.indvMetrics
                [makingSelectionsState]="makingSelectionsState"
                [isGroupSelected]=metricGroup.groupSelected
                [brandGroup]="tvdBrandGroupScope"
                [brands]="selectedFilterOptions[tvdBrandGroupScope]"
                [shouldShowCompositeMetric]="true"
                (groupMetricSelectionChange)="handleMetricGroupSelectionChange($event)">
            </tvd-metric-group>
        </div>

        <!-- Show Water, Energy and Waste (Plastic + Cardboard) quantity totals at a quick glance-->
        <div class="tvd-metric-summary-container relative flex flex-col gap-4 mx-6 mb-12 justify-around lg:flex-row">
            <div *ngFor="let metric of summaryPillMetrics" class="w-1/3 rounded-[28px] bg-neptune-gradient lg:min-w-[280px] md:min-w-[150px]">
                <tvd-metric-summary [metricId]="metric" [data]="getSummaryPillData(metric)" [selectedProgram]="tvdBrandGroupScope"/>
            </div>
        </div>
    </div>

    <!-- Modal Wrappers and additional components-->
    <ng-container *ngIf="selectionsPreviewState">
        <div class="neptune-modal-cover">
            <tvd-presentation-preview
                *ngIf="selectionsPreviewState"
                [tvdMetricGroupData]="tvdMetricGroupsDataForPresentationPreview"
                (saveSelection)="updatePresentationMetrics()"
                (exitPreview)="toggleSelectionsPreviewState()"
                (clearSelection)="clearSelectedTilesForPresentation()"
            >
            </tvd-presentation-preview>
        </div>
    </ng-container>


</div>

<!-- Making selections state bottom bar, outside of main container to make it appear as a footer -->
<div class="select-feature fixed bottom-0 neptune-page-bottom-container w-full gap-6 bg-white box-border px-8 py-4" *ngIf="makingSelectionsState" [hidden]="tvdBrandGroupScope!='All'">
    <div class="flex justify-between items-center w-full">
        <div class="selection-count flex justify-start items-center text-xl ml-20">
            <span class="text-bold">{{numMetricsSelected}}</span>&nbsp;item(s) selected
        </div>
        <div class="selection-actions flex gap-6 justify-end items-center">
            <button class="neptune-button-white" (click)="cancelMakingSelectionsState()">Cancel</button>
            <button [ngClass] = "areProductMetricsSelected ? 'neptune-button-white' : 'neptune-button-disabled'" [disabled]="!areProductMetricsSelected" (click)="toggleSelectionsPreviewState()">Preview</button>
            <button [ngClass] = "numMetricsSelected > 0 ? 'neptune-button-blue' : 'neptune-button-disabled'" (click)="updatePresentationMetrics()">Done</button>
        </div>
    </div>
</div>
